var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.media && _vm.media.length > 0)?_c('vue-lightbox',{attrs:{"media":_vm.media,"showLightBox":_vm.modalVisible},on:{"onClosed":function () { return (_vm.visible = false); }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }